package meineglasfaser.frontend.www.pages.order

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Text

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun OrderSuccessPage(ctx: PageContext) {
    val orderNid = ctx.route.params["nid"]

    Article {
        if (orderNid != null) {
            Header {
                H1 { Text("Bestellung erfolgreich aufgegeben!") }
            }
            Text("Ihre Bestellung (Nr. $orderNid) wurde aufgegeben. Sie erhalten in Kürze eine Bestätigung per E-Mail.")
        } else {
            Text("Bestellung $orderNid nicht gefunden.")
        }
    }
}
